import React, { Component } from 'react';
import Teleprompter from 'main/components/show/cuesheet.prompter/teleprompter.jsx';
import EventViewActions from 'flux/actions/EventViewActions';
import EventCrewListActions from 'flux/actions/EventCrewListActions';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import AlertBarAwareContainer from 'main/components/show/cuesheet/alertBarAwareContainer';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import MouseMovementWrapper from 'main/components/show/cuesheet.prompter/mouseMovementWrapper.jsx';
import TeleprompterHeader from 'main/components/show/cuesheet.prompter/teleprompterHeader.jsx';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class TeleprompterPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { params } = this.props;
    const { teamId, eventId, showId, rowId, columnId } = params;
    TeamViewActions.populate(teamId);
    EventViewActions.populate(teamId, eventId);
    EventShowListActions.populate(teamId, eventId);
    EventCrewListActions.populate(teamId, eventId);
    window.addEventListener('beforeunload', this._handleUnload);

    if (
      rowId &&
      rowId !== 'undefined' &&
      columnId &&
      columnId !== 'undefined'
    ) {
      FullScreenCuesheetActions.getShow(teamId, eventId, showId);

      FullScreenCuesheetActions.populateActivityAudits(
        teamId,
        eventId,
        showId,
        rowId,
        columnId,
        1,
        1,
      );

      FullScreenCuesheetActions.populateItemSetSubsetBuffered(
        teamId,
        eventId,
        showId,
        [columnId],
        [],
      );

      FullScreenCuesheetActions.populateShowCallers(teamId, eventId);
    } else {
      FullScreenCuesheetActions.populate(teamId, eventId, showId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { teamId, eventId, showId, rowId, columnId } = this.props.params;
    const {
      teamId: nextTeamId,
      eventId: nextEventId,
      showId: nextShowId,
      rowId: nextRowId,
      columnId: nextColumnId,
    } = nextProps.params;

    if (
      nextShowId !== showId ||
      nextRowId !== rowId ||
      nextColumnId !== columnId
    ) {
      if (!nextRowId || !nextColumnId) {
        FullScreenCuesheetActions.populate(nextTeamId, nextEventId, nextShowId);
      }

      if (nextRowId && nextColumnId) {
        FullScreenCuesheetActions.populateActivityAudits(
          teamId,
          eventId,
          showId,
          nextRowId,
          nextColumnId,
          1,
          1,
        );
      }

      if (nextColumnId && nextColumnId !== columnId) {
        FullScreenCuesheetActions.populateItemSetSubsetBuffered(
          teamId,
          eventId,
          showId,
          [nextColumnId],
          [],
        );
      }
    }
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._handleUnload);
  }

  render() {
    const { params, location } = this.props;
    const displaySplash = location.query ? location.query.displaySplash : false;

    return (
      <AlertBarAwareContainer className="show-featured-wrapper fullscreen">
        <TeleprompterHeader {...params} />
        <MouseMovementWrapper wrapperClass="show-featured-body-wrapper">
          <div className="show-featured-wrapper-editor">
            <Teleprompter
              {...{
                ...params,
                displaySplash,
              }}
            />
          </div>
        </MouseMovementWrapper>
      </AlertBarAwareContainer>
    );
  }

  _handleUnload(e) {
    // Cancel the event
    e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    e.returnValue = '';
  }
}

export default TeleprompterPage;
